import React from 'react'
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { SvgProps } from 'react-native-svg'
import * as Icons from './../../assets/icons'
import { Theme } from '@theme'

export type IconName = keyof typeof Icons

export interface IconProps extends SvgProps {
  name: IconName
  size?: number
  color?: string
  border?: boolean
  containerStyle?: StyleProp<ViewStyle>
  onPress?: () => void
}

export const Icon: React.FC<IconProps> = ({
  name,
  size,
  color,
  border = false,
  containerStyle,
  onPress,
  testID,
  ...props
}) => {
  const SvgIcon = Icons[name]

  const theme = useTheme()
  const styles = getStyle(theme)

  const defaultSize = border ? theme.iconSize.small : theme.iconSize.large

  return (
    <TouchableOpacity
      testID={testID}
      onPress={onPress}
      activeOpacity={onPress ? undefined : 1}
      style={[
        { pointerEvents: onPress ? 'auto' : 'none' },
        border && styles.borderContainer,
        containerStyle,
      ]}
    >
      <SvgIcon
        width={size || defaultSize}
        height={size || defaultSize}
        color={color || theme.colors.secondary}
        {...props}
      />
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    borderContainer: {
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.lightGrey,
      borderWidth: 1,
      borderRadius: theme.border.jumbo,
      padding: theme.spacing.sm,
    },
  })
